import { PROTOTYPE_MOBILE_PREFIX } from "../mobileRoutePrefix";

export const TABLET_INTRO_PATH = `${PROTOTYPE_MOBILE_PREFIX}/tablet-intro/:appId`;

export function tabletIntroPath(appId) {
    return `${PROTOTYPE_MOBILE_PREFIX}/tablet-intro/${encodeURIComponent(appId)}`;
}
